import { TableV2 } from '@leverege/ui-elements'
import React, { useMemo } from 'react'

import { formatDuration } from '../../../../util'

import S from './Table.css'

export default function StationUtilizationTable( { data, businessHours } ) {
  const columns = useMemo( () => {
    return [ {
      Header : () => null,
      accessor : 'name',
      minWidth : 60
    }, {
      id : 'timeOccupied',
      Header : 'Time Occupied',
      accessor : ( data ) => {
        if ( data.averageOccupied === 0 ) {
          return '-'
        }
        
        return formatDuration( data.averageOccupied, { daysToHours : true } )
      },
      width : null,
      minWidth : 93
    }, {
      id : 'timeUnoccupied',
      Header : 'Time Unoccupied',
      accessor : ( data ) => {
        if ( data.averageUnoccupied === 0 ) {
          return '-'
        }
        
        return formatDuration( data.averageUnoccupied, { daysToHours : true } )
      },
      width : null,
      minWidth : 93
    }, {
      id : 'petsPerHour',
      Header : 'Pets Per Hour',
      accessor : ( data ) => {
        const { services } = data
        const perHour = businessHours === 0 ?
          'N/A' :
          ( services.length / businessHours ).toFixed( 1 )
    
        return perHour
      },
      width : null,
      minWidth : 93
    } ]
  }, [ businessHours ] )

  return (
    <TableV2
      className={S.table}
      variant="analytics"
      data={data}
      columns={columns} />
  )
}
